var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('dashboard-stats'),_c('dashboard-table',{attrs:{"ccn":_vm.ccn,"verif":_vm.verif,"liquidation":_vm.liquidation}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }